import {
  fadeIn,
  slideInFromBottom,
  slideInFromLeft,
  slideInFromRight,
  slideInFromTop,
} from '../animations.css.ts';
import { responsiveStyle } from '../responsive/responsive-style.ts';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, boxShadows, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style } from '../layer.css';

export const popoverContent = style([
  {
    borderRadius: borderRadius.r8,
    padding: space.s16,
    backgroundColor: themeVars.container.primary.background.idle,
    animationDuration: '400ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    animationFillMode: 'forwards',
    willChange: 'transform, opacity',
    outline: 0,
    boxShadow: boxShadows.default,

    selectors: {
      '&[data-side="top"]': {
        animationName: `${slideInFromBottom}, ${fadeIn}`,
      },
      '&[data-side="right"]': {
        animationName: `${slideInFromLeft}, ${fadeIn}`,
      },
      '&[data-side="bottom"]': {
        animationName: `${slideInFromTop}, ${fadeIn}`,
      },
      '&[data-side="left"]': {
        animationName: `${slideInFromRight}, ${fadeIn}`,
      },
    },
  },
  responsiveStyle({
    mobile: {
      ...typography['bodySm'],
    },
    tablet: {
      ...typography['bodyMd'],
    },
  }),
]);
